import { render, staticRenderFns } from "./IndustryKnowledge.vue?vue&type=template&id=27407877&scoped=true&"
import script from "./IndustryKnowledge.vue?vue&type=script&lang=js&"
export * from "./IndustryKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./IndustryKnowledge.vue?vue&type=style&index=0&id=27407877&scoped=true&lang=css&"
import style1 from "./IndustryKnowledge.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27407877",
  null
  
)

export default component.exports